import { Col, Typography, useTheme } from "@commonlibs";
import { PartnerDto } from "common/models";
import PartnerBanner from "../PartnerBanner/PartnerBanner";
import useTranslate from "ui/locale/hooks/useTranslate";
import Map from "ui/common/components/display/Map/Map";
import ButtonWarningLink from "ui/router/components/ButtonWarningLink/ButtonWarningLink";
export interface PartnerDetailsProps {
    partner: PartnerDto;
}

function PartnerDetails({ partner, ...rest }: PartnerDetailsProps) {
    const { spacing } = useTheme();
    const translate = useTranslate();
    const showMap = partner.type === "physical-store" && partner.location;

    return (
        <Col gap={spacing[8]} {...rest}>
            <PartnerBanner partner={partner} />
            <Col gap={spacing[2]}>
                <Typography variant="body3Strong" light>
                    {partner.name}
                </Typography>
                <Typography variant="body3Medium">{partner.description}</Typography>
            </Col>
            {partner?.link && partner.type === "online-store" && (
                <ButtonWarningLink to={partner.link} target="blank" fullWidth label={translate("continueToStore")} />
            )}
            {showMap && (
                <Col gap={spacing[4]}>
                    <Typography variant="body3Strong">{translate("branchOffices")}</Typography>
                    <Map src={partner.location as string} />
                    <ButtonWarningLink to={partner.location as string} target="blank" label={translate("showRutesInMap")} fullWidth Icon={false} />
                </Col>
            )}
        </Col>
    );
}

export default PartnerDetails;
